
import React from 'react';
import './Sustainability.css';
import Layout from '../../AllComponents/Layout';


import bus from '../../../assets/images/Frame 1171279982.png'

import SPO from "../../../assets/Pdf/SPO.pdf"
import SLFF from "../../../assets/Pdf/SLFF.pdf"



const Sustainability = () => {


    return (
        <>

            <Layout>
                <section className='sustain-sec'>
                    <div className="container">
                        <div className="row">
                            <div className='col-12'>
                                <h2 className='headingRout'>
                                    Home / Governance / <span> Sustainability </span>
                                </h2>

                                <div className='sustainbanner'>
                                        <h1>Driving Sustainability Through Electric Mobility</h1>
                                    <div className='rightpart'>
                                        <figure>
                                            {/* <img src={emanagementimg} alt='img' /> */}
                                            {/* <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/sustainability_page_Desktop.png`} alt='img' /> */}
                                            <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/sustainability_page_Mweb.png`} alt='img' />

                                        </figure>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </section>


                <section>
                    <div className="container">
                        <div className="row">
                            <div className='col-12'>
                                <div className='sustaintext'>
                                    <div className='leftpart'>
                                    <h2>At Greencell Mobility Pvt Ltd (GMPL), sustainability is the driving force behind everything we do. We are shaping the future of public transport by making it cleaner, quieter, and more efficient.</h2>
                                    <div className='pdfsec'>
                                        <img src={bus}/>
                                        <div className='pdfs'>
                                            <a href={SPO+'#toolbar=0'} target='_blank'><button className='pdfcta' >SPO PDF <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/arrow.svg`} alt='img'/>  </button> </a>
                                            <a href={SLFF+'#toolbar=0'} target='_blank'> < button className='pdfcta'>SLFF PDF  <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/arrow.svg`} alt='img'/>  </button> </a>
                                        </div>

                                    </div>
                                    

                                    </div>

                                    <div className='rightpart'>
                                        <p>Our commitment to sustainability extends across every partof our business - from vehicle operations to energy use, community development, and governance.</p>
                                        <h6>Sustainable Operations, Greener Cities </h6>
                                        <p>
                                            GMPL is redefining mobility through electric bus operations not only in cities but also across rural & remote communities. With a fleetof over 1100 electric buses running across major Indian cities, GMPL has helped reduce more than 278K tonnes of CO₂ emissions since inception, supporting India’s transition toward cleaner air and lower carbon intensity.</p>
                                            <p>GMPL operations have also adopted:</p>
                                            <ul>
                                                <li> Energy-efficient charging and lighting systems to reduce electricity demand</li>
                                                <li>Bus washing water recycling plants</li>
                                                <li>Driving sustainable transport with full EPR compliance</li>
                                            </ul>
                                            <p>GMPL has also inked a significant power purchase agreement and made a strategic equity investment in a 1 MW Wind Solar Hybrid captive power plant (with annual generation capacity of 4.6 million units) situated in Ratlam, Madhya Pradesh. This groundbreaking initiative marks an industry-first, as it will see its inter-city electric buses in the state being powered predominantly by renewable energy, leading to incremental CO2 savings of ~38000 tonnes over the lifetime of buses.These actions ensure every journey we operate contributes to a greener and more sustainable future.</p>
                                        {/* <a href='#'> Read More </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section>
                    <div className='last-section' >
                    <div className="container">
                        <div className="row">
                            <div className='col-12'>
                                <div className='sustainbox'>
                                    <div className='leftpart'>
                                        <h6>Circular Approach to Resource Use</h6>
                                        <p>Sustainability at GMPL goes beyond operating electric buses - it’s about managing every resource responsibly. We follow a circular economy model that focuses on maximizing efficiency and minimizing waste.</p>
                                        Key initiatives with future plans include:
                                        <ul>
                                            <li>Battery health monitoring and second-life usage programs, ensuring safe and sustainable handling of EV batteries</li>
                                            <li>Integration of renewable energy in charging infrastructure for long-term carbon reduction</li>
                                        </ul>
                                        <p> This approach ensures that our sustainability impact is measurable, scalable, and lasting. </p>
                                        <h6>Empowering People, Enabling Change</h6>
                                        <p>GreenCell Mobility follows inclusive hiring practices which aim to reflect the diversity of the communities we serve.</p>
                                        <p>We have created direct jobs for 5,400 individuals, including 2,800+ coach captains, making us one of the largest electric mobility employers in the country. intercity routes—breaking barriers in a traditionally male-dominated sector.</p>
                                    </div>
                                    <div className='rightpart'>
                                        <p>We are committed to building a safe, inclusive, and future-ready workforce by :</p>
                                        <ul>
                                            <li>Conducting continuous skill development programs for EV maintenance teams</li>
                                            <li>Promoting equal opportunities and employee well-being</li>
                                            <li>Engaging with local communities to raise awareness about sustainable transport</li>
                                        </ul>
                                        <p>By empowering people with knowledge and opportunity, GMPL ensures that sustainability drives not just progress - but also positive social change. Committed to a Greener Future, every bus we operate is more than a vehicle, it’s a symbol of our commitment to a sustainable and inclusive tomorrow. Through innovation, responsibility, and collaboration, GMPL continues to lead India’s transition to zero-emission mobility, one electric journey at a time.</p>
                                        <p>Together, we’re powering a cleaner future — responsibly and efficiently.</p>
                                    </div>

                                </div>
                                <div className='statImages'>
                                    <img src='https://nuego.fra1.cdn.digitaloceanspaces.com/greencell-uat/images/Green%20KM.png'/>
                                    <img src='https://nuego.fra1.cdn.digitaloceanspaces.com/greencell-uat/images/FUEL.png'/>
                                    <img src='https://nuego.fra1.cdn.digitaloceanspaces.com/greencell-uat/images/CO2.png'/>
                                    <img src='https://nuego.fra1.cdn.digitaloceanspaces.com/greencell-uat/images/Tress%20Absorbing.png'/>
                                    <img src='https://nuego.fra1.cdn.digitaloceanspaces.com/greencell-uat/images/NetEmission.png'/>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </section>


            </Layout >

        </>
    )
}

export default Sustainability
